import { render, staticRenderFns } from "./PayRangeCard.vue?vue&type=template&id=65dcb416&scoped=true"
import script from "./PayRangeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeCard.vue?vue&type=style&index=0&id=65dcb416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcb416",
  null
  
)

export default component.exports